import { render, staticRenderFns } from "./WorksSelection.vue?vue&type=template&id=642a24ec&scoped=true&"
import script from "./WorksSelection.vue?vue&type=script&lang=js&"
export * from "./WorksSelection.vue?vue&type=script&lang=js&"
import style0 from "./WorksSelection.vue?vue&type=style&index=0&id=642a24ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642a24ec",
  null
  
)

export default component.exports